/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toggle-on-color[_ngcontent-%COMP%]{color:green!important}.toggle-off-color[_ngcontent-%COMP%]{color:initial}.menu-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff!important}"];
export { styles as styles };
